const userRoleReducer = (role = {}, action) => {
    switch(action.type){
        case 'SET_USER_ROLE':
            role = action.data
            return role;
        default:
            return role;
    }
}

export default userRoleReducer